import { render, staticRenderFns } from "./newsDesc.vue?vue&type=template&id=270a5c46&scoped=true&"
import script from "./newsDesc.vue?vue&type=script&lang=js&"
export * from "./newsDesc.vue?vue&type=script&lang=js&"
import style0 from "./newsDesc.vue?vue&type=style&index=0&id=270a5c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a5c46",
  null
  
)

export default component.exports